import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Tag } from 'primereact/tag';
import PropTypes from 'prop-types';
import { Divider } from 'primereact/divider';

const getSeverity = (index) => {
  const severities = ['success', 'info', 'warning', 'danger'];
  return severities[index % severities.length];
};

const TemplateModal = ({ visible, onClose, onTemplateSelect, templates = [] }) => {
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isMobile, setIsMobile] = React.useState(() => typeof window !== 'undefined' && window.innerWidth <= 600);

  useEffect(() => {
    const onResize = () => setIsMobile(typeof window !== 'undefined' && window.innerWidth <= 600);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const handleTemplateSelect = (template) => {
    setSelectedTemplate(template);
    onTemplateSelect(template);
  };

  return (
    <Dialog 
      header="Select Article Template" 
      visible={visible} 
      style={{ width: '50dvw' }}
      onHide={onClose}
      modal
      className="surface-card"
      maximizable={!isMobile}
      maximized={isMobile}
    >
      <div className="flex flex-column gap-4">
        <div className="flex flex-column gap-2">
          <h3>Select a template to start creating your article</h3>
          <p>Choose from our pre-defined templates to get started quickly.</p>
        </div>
        <Divider /> 

        <div className="grid">
          {templates.map((template, index) => (
            <Card 
              key={template.id}
              className={`p-3 cursor-pointer ${
                selectedTemplate === template.id ? 'surface-100' : 'hover:surface-100'
              }`}
              onClick={() => handleTemplateSelect(template.id)}
            >
              <div className="flex flex-column gap-2">
                <div className="flex align-items-center gap-2">
                  <i className={`pi ${template.icon || 'pi-file'} text-3xl`} />
                  <h4>{template.name}</h4>
<Tag 
                    value={template.id} 
                    severity={getSeverity(index)} 
                    className="ml-auto"
                  />
                </div>
                <p className="m-0 text-sm">{template.description}</p>
              </div>
            </Card>
          ))}
        </div>

        <div className="flex justify-content-end">
          <Button 
            label="Cancel" 
            onClick={onClose}
            className="p-button-text"
          />
          {selectedTemplate && (
            <Button 
              label="Continue" 
              onClick={() => {
                onTemplateSelect(selectedTemplate);
                onClose();
              }}
              className="p-button-primary ml-2"
            />
          )}
        </div>
      </div>
    </Dialog>
  );
};

TemplateModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onTemplateSelect: PropTypes.func.isRequired,
  templates: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    icon: PropTypes.string,
    component: PropTypes.string
  }))
};

TemplateModal.defaultProps = {
  templates: []
};

export default TemplateModal;
